<div class="container firma mt-4 mb-5" *ngIf="!isLoading">
    <div class="alert alert-danger" role="alert" *ngIf="activationError">
        <h4 class="alert-heading mt-2"><b>Error</b></h4>
        <p *ngIf="activationError">{{ activationError.error.error.msg }}</p>
    </div>

    <button class="btn btn-black-outline btn-block mb-5" *ngIf="activationError" (click)="activate('reintentar')" [disabled]="disabledActivate">
        <b>{{ disabledActivate ? 'Verificando pedido ' : 'Reintentar' }} <span *ngIf="disabledActivate" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span></b>
    </button>

    <div class="card mb-3">
        <div class="card-header bg-rm">
            <div class="d-flex justify-content-between align-items-center">
                <div>
                    <h6 class="subtitulo-pack2"><b>Cliente</b></h6>
                </div>
            </div>
        </div>

        <div class="card-body bg-white">
            <div class="row mt-4">
                <div class="col-lg-8">
                    <!-- Nombre cliente -->
                    <h5 class="title-list ms-3">
                        <a class="text-list" *ngIf="order.customer.document_type != 4">
                            <b>{{ order.customer.name + ' ' + order.customer.last_name + ' ' + order.customer.second_last_name }}</b>
                        </a>
                        <a class="text-list" *ngIf="order.customer.document_type == 4">
                            <b>{{ order.customer.company_name }}</b>
                        </a>
                        <br><br>
                        <!-- Contacto -->
                        <span class="font-list">
                            <img src="./assets/img/phone.svg" class="img-fluid" width="13">
                            Nº de contacto: <b>{{ order.customer.phone_number }}</b>
                        </span>
                        <br>
                        <!-- Tipo de alta -->
                        <span class="font-list">
                            <img src="./assets/img/package2.svg" class="img-fluid" width="13">
                            Tipo de alta: <b>
                            <ng-container *ngIf="typeOrder === 'convergent'">
                                {{ 'Alta fibra + ' + (order.mobiles[0]?.msisdn && order.mobiles[0].msisdn !== '' ? 'Portabilidad móvil' : 'Alta móvil') }}
                            </ng-container>
                            <ng-container *ngIf="typeOrder === 'mobile'">
                                {{ order.mobiles && order.mobiles.length && order.mobiles[0].msisdn && order.mobiles[0].msisdn !== '' ? 'Portabilidad móvil' : 'Alta móvil' }}
                            </ng-container>
                            <ng-container *ngIf="typeOrder === 'broadband'">Solo Fibra</ng-container>
                            <b class="info-secundaria" *ngIf="order.mobiles.length > 1">
                                + {{ order.mobiles.length - 1 }} línea(s) adicional(es)
                            </b>
                        </b>
                        </span>
                        <br *ngIf="order.mobiles && order.mobiles.length && order.mobiles[0].msisdn && order.mobiles[0].msisdn !== ''">
                        <!-- MSISDN -->
                        <span class="font-list" *ngIf="order.mobiles && order.mobiles.length && order.mobiles[0].msisdn && order.mobiles[0].msisdn !== ''">
                            <img src="./assets/img/file-black.svg" class="img-fluid" width="13">
                            Línea móvil: <b>{{ order.mobiles[0].msisdn }}</b>
                        </span>
                        <br>
                        <!-- Fecha de solicitud -->
                        <span class="font-list">
                            <img src="./assets/img/clock.svg" class="img-fluid" width="13">
                            Fecha de solicitud: <b>{{date | date:'dd/MM/yyyy':'UTC+1'}}</b>
                        </span>
                        <br>
                        <!-- Documento de identidad -->
                        <span class="font-list">
                            <img src="./assets/img/file-black.svg" class="img-fluid" width="13">
                            {{ getDocumentLabel(order.customer.document_type) }}: <b>{{ order.customer.document }}</b>
                        </span>
                        <br>
                        <!-- Nº de contrato -->
                        <span class="font-list">
                            <img src="./assets/img/package2.svg" class="img-fluid" width="13"> Nº de contrato: <b>-</b>
                        </span>
                        <br>
                        <!-- Comentarios -->
                        <!--<span class="font-list"> Comentarios: <b>-</b></span><br><br>-->
                    </h5>
                </div>
                <div align="right" class="col-lg-4">
                    <div class="col-lg-12 mb-2">
                        <span class="badge badge-pill badge-success font-list"
                                *ngIf="(typeOrder === 'convergent' || typeOrder === 'broadband') && rateFtth">
                            <span *ngIf="typeOrder === 'convergent'">
                                {{ rateFtth.name + '+' + ratesMobiles[0]?.name + ': ' + priceWithIVA(rateFtth.rateAmount + ratesMobiles[0]?.rateAmount - rateFtth.discount).toFixed(0) }} €
                            </span>
                            <span *ngIf="typeOrder === 'broadband'">
                                {{ rateFtth.name + ': ' + priceWithIVA(rateFtth.rateAmount).toFixed(0) }} €
                            </span>
                        </span>
                    </div>
                    <div class="col-lg-12 mb-2" *ngFor="let mobile of order.mobiles; index as i">
                        <span class="badge badge-pill badge-success font-list" *ngIf="mobile.rate && !(typeOrder === 'convergent' && i === 0)">
                            {{ mobile.rate?.name + ': ' + priceWithIVA(mobile.rate.rateAmount).toFixed(0) }} €
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="card">
        <div class="card-header bg-rm">
            <div class="d-flex justify-content-between align-items-center">
                <div>
                    <h6 class="subtitulo-pack2 ms-3">
                        <img src="./assets/img/file-text-negro.svg" class="img-fluid ico-title" width="13">
                        <b>Resumen de la tramitación</b>
                    </h6>
                </div>
            </div>
        </div>

        <div class="bg-white">
            <div class="row">
                <div class="col-md-12">
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item cuerpo-pack-2">
                            <!-- Solo Fibra -->
                            <div *ngIf="typeOrder === 'broadband' && rateFtth">
                                <h5 align="left" class="tar-name-7 mt-2 ms-3"><b>Solo Fibra</b></h5>

                                <div class="resumen d-flex justify-content-between align-items-center">
                                    <span class="sidebar-info4 verde"> Conceptos</span>
                                    <small class="text-muted"></small>
                                </div>

                                <div class="resumen d-flex justify-content-between align-items-center">
                                    <!-- tarifa -->
                                    <span class="sidebar-info5">
                                        <img src="./assets/img/package2.svg" class="img-fluid" width="13">
                                        {{ rateFtth.name }}
                                    </span>
                                    <small class="text-muted">
                                        <!-- Precio tarifa -->
                                        <span class="sidebar-info3">
                                            <b>{{ priceWithIVA(rateFtth.rateAmount).toFixed(0) }} €/mes</b>
                                        </span>
                                    </small>
                                </div>

                                <div class="resumen d-flex justify-content-between align-items-center mt-2">
                                    <span class="sidebar-info">
                                        <b>Total</b>
                                    </span>
                                    <small class="text-muted trash-carrito">
                                        <!-- Precio tarifa -->
                                        <span class="sidebar-info2">
                                            <b>{{ priceWithIVA(rateFtth.rateAmount).toFixed(0) }} €/mes</b>
                                        </span>
                                    </small>
                                </div>
                            </div>

                            <!-- RESUMEN MOVIL PACK -->
                            <div *ngIf="typeOrder === 'convergent' && rateFtth && order.mobiles.length > 0">
                                <div class="resumen d-flex justify-content-between align-items-center mt-2">
                                    <h5 align="left" class="tar-name-7 mt-2">
                                        <b>Fibra y móvil</b>
                                    </h5>
                                    <small class="text-muted trash-carrito">
                                        <!-- editar producto -->
                                        <a (click)="goToStep(0)">
                                            <img src="./assets/img/edit.svg" class="img-fluid icon-nav-sidebar" width="15">
                                        </a>
                                    </small>
                                </div>

                                <div class="resumen d-flex justify-content-between align-items-center">
                                    <span class="sidebar-info4 verde"> Conceptos</span>
                                    <small class="text-muted"></small>
                                </div>

                                <div class="resumen d-flex justify-content-between align-items-center">
                                    <!-- tarifa -->
                                    <span class="sidebar-info5">
                                        <img src="./assets/img/package2.svg" class="img-fluid" width="13">
                                        {{ rateFtth.name }}
                                    </span>
                                    <small class="text-muted">
                                        <!-- Precio tarifa -->
                                        <span class="sidebar-info3">
                                            <b>{{ priceWithIVA(rateFtth?.rateAmount).toFixed(0) }} €/mes</b>
                                        </span>
                                    </small>
                                </div>

                                <div class="resumen d-flex justify-content-between align-items-center" *ngIf="order.mobiles && order.mobiles.length">
                                    <!-- tarifa -->
                                    <span class="sidebar-info5">
                                        <img src="./assets/img/package2.svg" class="img-fluid" width="13">
                                        <span>{{ order.mobiles[0].rate?.name }} ({{ order.mobiles[0].rate?.contractType === 'postpaid' ? 'Pospago' : 'Prepago' }})</span>
                                        <br>
                                        <span>{{ order.mobiles[0].rate?.labelData }} + {{ order.mobiles[0].rate?.resumeLabelVoice }}</span>
                                    </span>
                                    <small class="text-muted">
                                       <!-- Precio tarifa -->
                                        <span class="sidebar-info3">
                                            <b>{{ priceWithIVA(order.mobiles[0]?.rate?.rateAmount).toFixed(0) }} €/mes</b>
                                        </span>
                                    </small>
                                </div>

                                <div class="resumen d-flex justify-content-between align-items-center mt-2">
                                    <span class="sidebar-info">
                                        Descuento por fibra y móvil
                                    </span>
                                    <small class="text-muted trash-carrito">
                                        <!-- Precio tarifa -->
                                        <span class="sidebar-info2">
                                            <b>-{{ priceWithIVA(rateFtth?.discount).toFixed(0) }} €/mes</b>
                                        </span>
                                    </small>
                                </div>
                                <div class="resumen d-flex justify-content-between align-items-center mt-2"  *ngIf="order.mobiles[0].msisdn !== '' && order.mobiles[0].processing_date != '' && order.mobiles[0].processing_date != undefined ">
                                    <!-- Info fecha porta -->
                                    <span class="sidebar-info5" >
                                        <small>
                                            Fecha de portabilidad: <strong>{{ order.mobiles[0].processing_date  | date: 'dd/MM/yyyy' : '+1000' }}</strong>
                                        </small>
                                    </span>
                                </div>

                                <div class="resumen d-flex justify-content-between align-items-center mt-2">
                                    <span class="sidebar-info">
                                        <b>Total</b>
                                    </span>
                                    <small class="text-muted trash-carrito">
                                        <!-- Precio tarifa -->
                                        <span class="sidebar-info2">
                                            <b>{{ priceWithIVA(rateFtth?.rateAmount + order?.mobiles[0]?.rate?.rateAmount - rateFtth?.discount).toFixed(0) }} €/mes</b>
                                        </span>
                                    </small>
                                </div>

                            </div>

                            <!-- RESUMEN LÍNEA ADICIONAL -->

                            <div *ngFor="let mobile of order.mobiles; index as i" [hidden]="typeOrder === 'convergent' && i === 0">
                                <hr *ngIf="typeOrder !== 'mobile' || i > 0">

                                <div class="resumen d-flex justify-content-between align-items-center mt-2">
                                    <h5 align="left" class="tar-name-7 mt-2">
                                        <b>{{ i === 0 ? 'Línea móvil principal' : 'Línea móvil adicional' }}</b>
                                    </h5>
                                    <span class="d-flex justify-content-end align-items-center">
                                        <small class="text-muted trash-carrito">
                                            <!-- editar producto -->
                                            <a (click)="goToStep(i + (rateFtth ? 1 : 0))">
                                                <img src="./assets/img/edit.svg" class="img-fluid icon-nav-sidebar" width="15">
                                            </a>
                                        </small>
                                        <small class="text-muted trash-carrito" *ngIf="i > 0">
                                            <!-- eliminar producto -->
                                            <a (click)="removeExtraLine(i)" class="ps-2">
                                                <img src="./assets/img/trash.svg" class="img-fluid icon-nav-sidebar" width="15">
                                            </a>
                                        </small>
                                    </span>
                                </div>

                                <!-- CONCEPTOS -->
                                <div class="resumen d-flex justify-content-between align-items-center">
                                    <span class="sidebar-info4 verde"> Conceptos</span>
                                    <small class="text-muted">
                                    </small>
                                </div>

                                <div class="resumen d-flex justify-content-between align-items-center">
                                    <!-- tarifa -->
                                    <span class="sidebar-info5">
                                        <img src="./assets/img/package2.svg" class="img-fluid" width="13">
                                        <span>{{ mobile.rate?.name }} ({{ mobile.rate?.contractType === 'postpaid' ? 'Pospago' : 'Prepago' }})</span>
                                        <br>
                                        <span>{{ mobile.rate?.labelData }} + {{ mobile.rate?.resumeLabelVoice }}</span>
                                    </span>
                                    <small class="text-muted">
                                        <!-- Precio tarifa -->
                                        <span *ngIf="rateFtth && i === 0" class="sidebar-info3">
                                            <b>{{ priceWithIVA(mobile?.rate?.rateAmount - rateFtth?.discount).toFixed(0) }} €/mes</b>
                                        </span>
                                        <span *ngIf="rateFtth === null || i !== 0" class="sidebar-info3">
                                            <b>{{ priceWithIVA(mobile?.rate?.rateAmount).toFixed(0) }} €/mes</b>
                                        </span>
                                    </small>
                                </div>
                                <div class="resumen d-flex justify-content-between align-items-center mt-2"  *ngIf="mobile.msisdn !== '' && mobile.processing_date != '' && mobile.processing_date != undefined ">
                                    <!-- Info fecha porta -->
                                    <span class="sidebar-info5" >
                                        <small>
                                            Fecha de portabilidad: <strong>{{ mobile.processing_date  | date: 'dd/MM/yyyy' : '+1000' }}</strong>
                                        </small>
                                    </span>
                                </div>

                                <div class="resumen d-flex justify-content-between align-items-center mt-2">
                                    <span class="sidebar-info"><b>Total</b></span>
                                    <small class="text-muted trash-carrito">
                                        <!-- Precio tarifa -->
                                        <span *ngIf="rateFtth && i === 0" class="sidebar-info2">
                                            <b>{{ priceWithIVA(mobile?.rate?.rateAmount - rateFtth?.discount).toFixed(0) }} €/mes</b>
                                        </span>
                                        <span *ngIf="rateFtth === null || i !== 0" class="sidebar-info2">
                                            <b>{{ priceWithIVA(mobile?.rate?.rateAmount).toFixed(0) }} €/mes</b>
                                        </span>
                                    </small>
                                </div>
                            </div>

                            <hr>

                            <!-- <div class="resumen d-flex justify-content-between align-items-center">
                                <span class="sidebar-info">Importe sin <b>IVA</b></span>
                                <small class="text-muted trash-carrito"> -->
                                    <!-- Importe sin IVA -->
                                    <!-- <span class="sidebar-info2"><b>{{ totalPrice.toFixed(0) }} €/mes</b></span>
                                </small>
                            </div> -->

                            <!-- Importe Total -->
                            <div class="resumen-total total d-flex justify-content-between align-items-center"
                                *ngIf="(rateFtth && order.mobiles.length > 1) || (!rateFtth && order.mobiles.length > 1)">
                                <h5 class="total-color"><b>total</b></h5>
                                <h5 class="text-auto"><b>{{ priceWithIVA(totalPrice).toFixed(0) }} €/mes</b></h5>
                            </div>
                            <div class="resumen-total total d-flex justify-content-between align-items-center">
                                <span class="total-color"><b>IVA incluido</b></span>
                            </div>
                            <hr>
                            <br>
                            <br>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container" [formGroup]="form" *ngIf="!isLoading">
    <div class="area-check">
        <div class="checkbox icheck-primary">
            <input type="checkbox" id="primary" class="accept-check" formControlName="check1"/>
            <label for="primary">Acepto recibir comunicaciones comerciales de República Móvil personalizadas para mi perfil</label>
            <mat-error *ngIf="errorHandling('check1', 'required')">
                <small class="ps-4 ms-1">Campo obligatorio.</small>
            </mat-error>
        </div>

        <div class="checkbox icheck-primary">
            <input type="checkbox" id="secondary" class="accept-check" formControlName="check2" required/>
            <label for="secondary">Acepto las <a href="https://republicamovil.es/informacion-legal/" target="_blank">condiciones generales</a>, de portabilidad y la <a href="https://republicamovil.es/politica-privacidad-blog/" target="_blank">política de privacidad.</a></label>
            <mat-error *ngIf="errorHandling('check2', 'required')">
                <small class="ps-4 ms-1">Campo obligatorio.</small>
            </mat-error>
        </div>
    </div><!-- ./ area check -->

    <br><br>
</div>

<div class="container firma" *ngIf="!isLoading">
    <div class="row">
        <div class="col-md-12">
            <button (click)="activate('activar')" class="btn btn-black-outline btn-block mb-5" [disabled]="disabledActivate"><b>{{ disabledActivate ? 'Verificando pedido ' : 'Activar servicios' }} <span *ngIf="disabledActivate" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span></b></button>
        </div>
    </div>
</div>

<app-rm-loader *ngIf="isLoading" (onPreloadingComplete)="preloadingComplete()" [startGetStatus]="startGetStatusTime"></app-rm-loader>
